import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Antd from 'ant-design-vue'
import * as echarts from 'echarts'
import '@/style/main.less'
import '@/style/components.less'
// 登录上方的
import NProgress from 'nprogress'
import config from '@/utils/config'
import 'nprogress/nprogress.css'
const app = createApp(App)
app.config.warnHandler = () => null  //清除控制台警告
app.config.globalProperties.$echarts = echarts
    //定义全局变量
    // app.config.globalProperties.global = global
window.addEventListener("popstate", function() {
    history.pushState(null, null, document.URL);
});
router.beforeEach((to, from, next) => {
    // 登录进度条
    NProgress.start();
    store.commit("clearToken");
    if (to.path === '/') {
        next({
            path: '/index.html',
        });
    }
    if (to.path === config.loginURL) {
        localStorage.clear()
        next();
        return;
    }
    let isToken = Boolean(localStorage.getItem("token"));
    if (isToken) {
        if(localStorage.getItem('loginInfo')) {
            next();
        }
        else {
            localStorage.clear()
            next({
                path: config.loginURL,
            });
        }
        // 取消请求 
        
    } else {
        if (to.path === config.loginURL) {
            localStorage.clear()
            next();
        } else {
            localStorage.clear()
            next({
                path: config.loginURL,
            });
        }
    }
    if (to.meta.title) {
        document.title = to.meta.title;
    }

})
router.afterEach(() => {
    //进度条结束
    NProgress.done();
});
app.use(Antd).use(store).use(router).mount('#app')